(() => {
  if (customElements.get('izuro-product-experience')) return;
  customElements.define('izuro-product-experience', class extends HTMLElement {
    connectedCallback() {
      // The three editable hero reviews also populate this gallery until the
      // merchant adds a separate set of full-length photo reviews here.
      const reviewWall = this.querySelector('[data-review-wall]');
      const featured = [...document.querySelectorAll('.iz-hero-testimonials__card')];
      if (reviewWall && Number(this.dataset.realReviewCount) === 0 && featured.length) {
        const cards = featured.map(source => {
          const article = document.createElement('article');
          article.className = 'izxp-wall-card';
          article.dataset.wallCard = '';
          const image = source.querySelector('.iz-hero-testimonials__media img');
          if (image) article.append(image.cloneNode(true));
          const body = document.createElement('div');
          body.className = 'izxp-wall-body';
          const name = document.createElement('strong');
          name.textContent = source.querySelector('.iz-hero-testimonials__author > span')?.textContent || '';
          body.append(name);
          const stars = source.querySelector('.iz-hero-testimonials__stars');
          if (stars) {
            const rating = document.createElement('p');
            rating.className = 'izxp-story-stars';
            rating.setAttribute('aria-label', stars.getAttribute('aria-label') || 'Customer rating');
            rating.textContent = stars.textContent;
            body.append(rating);
          }
          const quote = document.createElement('div');
          quote.className = 'rte';
          const paragraph = document.createElement('p');
          paragraph.textContent = source.querySelector('.iz-hero-testimonials__quote')?.textContent || '';
          quote.append(paragraph);
          body.append(quote);
          const verified = source.querySelector('.iz-hero-testimonials__verified');
          if (verified) {
            const mark = document.createElement('span');
            mark.className = 'izxp-verified';
            mark.textContent = '✓ Verified customer';
            body.append(mark);
          }
          article.append(body);
          return article;
        });
        reviewWall.replaceChildren(...cards);
        const heading = this.querySelector('.izxp-review-heading h2');
        if (heading && this.dataset.reviewsHeading) heading.textContent = this.dataset.reviewsHeading;
      }
      this.rail = this.querySelector('[data-carousel]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.dots = this.querySelector('[data-carousel-dots]');
      this.cards = [...(this.rail?.querySelectorAll('.izxp-story-card') || [])];
      this.more = this.querySelector('[data-review-more]');
      this.hiddenCards = [...this.querySelectorAll('[data-wall-card][hidden]')];
      this.onClick = event => {
        if (event.target.closest('[data-carousel-prev]')) this.move(-1);
        if (event.target.closest('[data-carousel-next]')) this.move(1);
        if (event.target.closest('[data-review-more]')) this.showMore();
      };
      this.addEventListener('click', this.onClick);
      if (this.rail && this.cards.length > 0) {
        this.dots.replaceChildren();
        this.cards.forEach((card,index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to photo ${index + 1}`);
          dot.addEventListener('click', () => this.go(index));
          this.dots.append(dot);
        });
        this.update = () => {
          const left = this.rail.scrollLeft;
          const closest = this.cards.reduce((best,card,index) => Math.abs(card.offsetLeft-this.cards[0].offsetLeft-left)<Math.abs(this.cards[best].offsetLeft-this.cards[0].offsetLeft-left)?index:best,0);
          this.dots.querySelectorAll('button').forEach((dot,index) => dot.setAttribute('aria-current',String(index===closest)));
          this.prev.disabled = left <= 2;
          this.next.disabled = left + this.rail.clientWidth >= this.rail.scrollWidth - 2;
          this.dots.hidden = this.rail.scrollWidth <= this.rail.clientWidth + 2;
        };
        this.rail.addEventListener('scroll',this.update,{passive:true});
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.rail);
        requestAnimationFrame(this.update);
      }
      if (this.more) this.more.hidden = this.hiddenCards.length === 0;
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.onClick);
      this.rail?.removeEventListener('scroll',this.update);
      this.resize?.disconnect();
    }
    go(index) {
      const card = this.cards[index];
      if (!card) return;
      this.rail.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    move(direction) {
      const left = this.rail.scrollLeft;
      const current = this.cards.reduce((best,card,index) => Math.abs(card.offsetLeft-this.cards[0].offsetLeft-left)<Math.abs(this.cards[best].offsetLeft-this.cards[0].offsetLeft-left)?index:best,0);
      this.go(Math.max(0,Math.min(this.cards.length-1,current+direction)));
    }
    showMore() {
      this.hiddenCards.forEach(card=>{card.hidden=false;});
      this.hiddenCards=[];
      this.more.hidden=true;
    }
  });
})();
